import { hideNativeModuleSwitcher } from 'mini-host-bridge/lib/utils/hideNativeModuleSwitcher';
import { MODULE_SWITCHER_STATE } from 'mini-host-bridge/lib/nativeMessageConstants';
import { overrideModuleSwitcherHeight } from 'mini-mail-list-view/lib/utils/mailList/moduleSwitcherHeight';
import { sendScenarioDataToHost } from 'mini-host-bridge/lib/utils/sendScenarioDataToHost';

export const setNativeModuleSwitcherState = (isVisible: boolean) => {
    if (isVisible) {
        overrideModuleSwitcherHeight(0);
        sendScenarioDataToHost({
            type: MODULE_SWITCHER_STATE,
            data: { mounted: true },
        });
    } else {
        overrideModuleSwitcherHeight(56);
        hideNativeModuleSwitcher();
    }
};
